import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IUserSearchResult } from 'app/features/studentsearch/studentsearch';
import { ErrorService, MultiplePathwaysSerivce, UserService, UtilityService } from 'src/app/core/services';
import { SplashDialogService } from '../splash';
import { UserSearchDialogOptions } from './usersearch-dialog';


export class SearchParams {
    FirstName?: string | null;
    LastName?: string | null;
    SAPID?: string | null;
}

@Component({
    selector: 'app-usersearch-dialog',
    templateUrl: './usersearch-dialog.component.html',
    styleUrls: ['./usersearch-dialog.component.scss', '../../../../themes/table.scss']
})
export class UserSearchDialogComponent implements OnInit {
    dataSource: MatTableDataSource<IUserSearchResult> = new MatTableDataSource<IUserSearchResult>([]);
    dataColumns = ["LastName", "FirstName", "SAPID", "PositionNo", "LocalJobTitle", "Email"];
    displayedColumns = [...this.dataColumns, 'actions'];

    TitleText = 'Multpiple Pathway Programs User Search';
    MessageText = '';
    ForcedLocationNumber: string | null = null;
    FoundUser: IUserSearchResult | null = null;
    UserSearchConducted = false;
    Searching = false;
    UserSearchResults: IUserSearchResult[] | null = null;
    ConfirmationIsUp = false;
    User: any = null;

    SearchParamsForm = this.formBuilder.group({
        LastName: [null],
        FirstName: [null],
        SAPID: [null],
    });

    // #region - Getters for form

    get SearchParams() { return this.SearchParamsForm.value; }

    // #endregion

    @ViewChild(MatPaginator) paginator: MatPaginator | null = null;
    @ViewChild(MatSort) sort: MatSort | null = null;

    constructor(
        private dialogRef: MatDialogRef<UserSearchDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public opts: UserSearchDialogOptions,
        private formBuilder: UntypedFormBuilder,
        private errorService: ErrorService,
        private REALServices: MultiplePathwaysSerivce,
        private userService: UserService,
        private splashService: SplashDialogService,
    ) {
        const self = this;
        self.dataSource.data = [];
        self.TitleText = opts.TitleText || 'Multpiple Pathway Programs User Search';
        self.MessageText = opts.MessageText || '';
        self.ForcedLocationNumber = opts.ForcedLocationNumber || null;
        self.User = self.userService.UserValue;
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        const self = this;
        self.dataSource.paginator = self.paginator;
        self.dataSource.sort = self.sort;
    }

    loadDataSource(data: IUserSearchResult[]): void {
        const self = this;
        self.dataSource = new MatTableDataSource(data);
        self.dataSource.paginator = self.paginator;
        self.dataSource.sort = self.sort;
    }

    SelectUser(user: IUserSearchResult) {
        const self = this;
        self.FoundUser = user;
        self.OKHandler();
    }

    ClearUserForm(event: Event) {
        const self = this;
        if (event) event.preventDefault();

        self.SearchParamsForm.reset();

        (<HTMLElement>document.getElementById('lastname')).focus();
    };

    HandleUserSearch(event?: Event) {
        const self = this;
        if (event) event.preventDefault();
        self.UserSearchConducted = true;
        self.Searching = true;

        // There must be at least 1 of either first name, last name, or SAPID provided. We will not allow a search on 300000+ users without something!
        if ((self.SearchParams.FirstName == null || self.SearchParams.FirstName == '') && (self.SearchParams.LastName == null || self.SearchParams.LastName == '') && (self.SearchParams.SAPID == null || self.SearchParams.SAPID == '')) {
            self.splashService.SnackbarError('You must provide at least one search option in order to conduct a search.');
            return;
        }

        // Pad SAPID, if provided, up to 8 characters
        if (self.SearchParams.SAPID != null && self.SearchParams.SAPID.length > 0) self.SearchParams.SAPID = ('00000000' + self.SearchParams.SAPID).slice(-8);

        // Call the search for the user
        self.REALServices.SearchForUser(
            self.User.AuthToken, 
            self.User.CurrentRole, 
            self.SearchParams.FirstName, 
            self.SearchParams.LastName, 
            self.SearchParams.SAPID, 
            self.ForcedLocationNumber
        ).subscribe(
            (users: IUserSearchResult[]) => {
                // Update into table with search results
                self.UserSearchResults = users ?? [];
                self.loadDataSource(self.UserSearchResults);
                self.UserSearchConducted = true;
                self.Searching = false;
            }, 
            error => self.errorService.HandleServiceError(error)
            );
    };

    HandleUserKey(event: Event) {
        if (event != null) {
            // User hit enter. Send the search.
            this.HandleUserSearch(event);
            return;
        }
    }

    CancelHandler(): void {
        this.dialogRef.close(null);
    }

    OKHandler(): void {
        this.FoundUser != null ? this.dialogRef.close(this.FoundUser) : this.dialogRef.close(null);
    };
}
